import ComparisonTable from "./ComparisonTable/ComparisonTable";
import styled from "styled-components";
import TableActionButton from "../../../@ui/TableActionButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import LayerBreadcrumbs from "../Layers/LayerNavigation/LayerBreadcrumbs";
import { useEffect, useState } from "react";
import { LicenceTypeSummary } from "../../../types/Licences/LicenceTypeSummary";
import { LicenceTypeUpdateRequest } from "../../../types/Licences/LicenceTypeUpdateRequest";
import LicenceTypeCreateModal from "../../modal/LicenceType/CreateModal/LicenceTypeCreateModal";
import { TableActionButtonDelete } from "../../../@ui/TableActionButtonDelete";
import LicenceTypeEditModal from "../../modal/LicenceType/EditModal/LicenceTypeEditModal";
import LicenceTypeDeleteModal from "../../modal/LicenceType/DeleteModal/LicenceTypeDeleteModal";
import { useLicenceTypeAdminService } from "../../../hooks";
import { LicenceTypeCreateRequest } from "../../../types/Licences/LicenceTypeCreateRequest";
import { Alert } from "react-bootstrap";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;

const StyledIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
`;

const LicenceTypes = () => {
  const licenceTypeAdminService = useLicenceTypeAdminService();
  const [licenceTypeSummary, setLicenceTypeSummary] =
    useState<LicenceTypeSummary>();
  const [showEditForm, setShowEditForm] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  useEffect(() => {
    licenceTypeAdminService.GetLicenceSummaries().then((x) => {
      setLicenceTypeSummary(x);
    });
  }, [licenceTypeAdminService]);

  const handleCloseEditForm = () => {
    setShowEditForm(false);
  };

  const handleEditFormSubmit = async (values: LicenceTypeUpdateRequest) => {
    await licenceTypeAdminService.UpdateLicenceType(values);
    setShowEditForm(false);
    setLicenceTypeSummary(await licenceTypeAdminService.GetLicenceSummaries());
  };

  const handleCreateFormSubmit = async (values: LicenceTypeCreateRequest) => {
    await licenceTypeAdminService.CreateLicenceType(values);
    setShowCreateForm(false);
    setLicenceTypeSummary(await licenceTypeAdminService.GetLicenceSummaries());
  };

  const handleDeleteFormSubmit = async (id: number) => {
    await licenceTypeAdminService.DeleteLicenceType(id);
    setShowDeleteForm(false);
    setLicenceTypeSummary(await licenceTypeAdminService.GetLicenceSummaries());
  };

  return (
    <>
      {licenceTypeSummary && (
        <>
          <div className="d-flex flex-column h-100">
            <div className="d-flex align-items-end justify-content-between mb-3">
              <LayerBreadcrumbs />
              <ButtonContainer>
                <TableActionButton onClick={() => setShowCreateForm(true)}>
                  {" "}
                  <StyledIcon icon={faPlus} />
                  Create
                </TableActionButton>
                <TableActionButton onClick={() => setShowEditForm(true)}>
                  {" "}
                  <StyledIcon icon={faPencil} />
                  Update
                </TableActionButton>
                <TableActionButtonDelete
                  onClick={() => setShowDeleteForm(true)}>
                  {" "}
                  <StyledIcon icon={faTrash} />
                  Delete
                </TableActionButtonDelete>
              </ButtonContainer>
            </div>
            <div
              className="flex-grow-1 mb-3"
              style={{
                overflow: "auto",
              }}>
              <ComparisonTable licenceTypeSummary={licenceTypeSummary} />
            </div>
            <Alert variant="warning" className="mb-3">
              Note: Changes to licences will require a container restart in AWS
            </Alert>
          </div>

          <LicenceTypeEditModal
            licenceTypeSummary={licenceTypeSummary}
            show={showEditForm}
            onClose={handleCloseEditForm}
            onSubmit={handleEditFormSubmit}
          />
          <LicenceTypeCreateModal
            licenceTypeSummary={licenceTypeSummary}
            show={showCreateForm}
            onClose={() => setShowCreateForm(false)}
            onSubmit={handleCreateFormSubmit}
          />
          <LicenceTypeDeleteModal
            licenceTypeSummary={licenceTypeSummary}
            show={showDeleteForm}
            onClose={() => setShowDeleteForm(false)}
            onSubmit={handleDeleteFormSubmit}
          />
        </>
      )}
    </>
  );
};

export default LicenceTypes;
